import styles from "./styles/uploadAvatar.module.css";
import uploadButton from "./styles/img/uploadButton.png";
import editButton from "./styles/img/edit_button.svg";
import { Spin, Upload as UploadProfilePicture } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import config from "../../../config";
import { UserData } from "../../../Context/DataContext";
import CropperImage from "antd-cropper-img";
import { encryptFileAES } from "../../../Utils/OstreonEncryption";
const base_url = config.base_url;
export default function UploadAvatar({
  modalTitle = undefined,
  uploadButtonStyles,
  editIconStyles,
  previewContainerStyles,
  uploadTriggerStyles,
  profile_id,
  profile_avatar = null,
  you = false,
  onEdit,
  /*
    The avatar is not this viewer's to change -- the partner's view of a
    customer.

    A photo has no sharing flag, so the server never sends one and there is
    nothing to upload against. The ordinary placeholder is still drawn, so the
    card looks like every other card, but nothing here responds to a click.
  */
  readOnly = false,
  /*
    A read-only viewer who may nonetheless ASK for this picture to change --
    a partner granted the beneficiary's picture row.

    They get a click, not an uploader. Everything below posts straight to
    the profile-picture endpoint, which writes into the SESSION user's own
    folder and answers to nobody: for a partner that is their own directory
    and it would bypass the proposal system entirely. So the click opens the
    record instead, where the change becomes a proposal the customer
    answers.
  */
  canRequestEdit = false,
}) {
  const userData = UserData();

  const [previewImage, setPreviewImage] = useState(null);
  const [avatarImage, setAvatarImage] = useState(profile_avatar);
  const [editingImage, setEditingImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const uploadImageHandler = async (file) => {
    if (!file) return;
    if (userData.isFreezed) return;

    setLoading(true);
    const formData = new FormData();
    const encrypted_image = await encryptFileAES(userData.private_key, file);
    formData.append("file", encrypted_image);
    formData.append("profile_id", profile_id);
    await fetch(base_url + "user/profile/pic/upload", {
      method: "POST",
      mode: "cors",
      body: formData,
      credentials: "include",
    })
      .then((res) => res.json())
      .then(async (res) => {
        !you && (await userData.getCustomerBeneficiary());
        you && (await userData.getUserData());
      })
      .then(() => {
        setEditingImage(false);
      });
  };

  useEffect(() => {
    setAvatarImage(profile_avatar);
    if (profile_avatar) {
      setPreviewImage(null);
    }
    setLoading(false);
  }, [profile_avatar]);

  const deleteImageHandler = async () => {
    setLoading(true);
    await fetch(base_url + "user/profile/pic/delete", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `profile_id=${profile_id}`,
      credentials: "include",
    })
      .then((res) => res.json())
      .then(async (res) => {
        !you && (await userData.getCustomerBeneficiary());
        userData.getUserData();
        you &&
          (await userData.setUserData((prev) => {
            return {
              ...prev,
              profile_avatar: null,
            };
          }));
        setAvatarImage(null);
        setPreviewImage(null);
      });
  };
  let extension;
  let editButtonStyle = {};
  let uploadButtonStyle = {};
  let propsUploadTriggerStyles = {};

  if (uploadTriggerStyles) {
    propsUploadTriggerStyles = { ...uploadTriggerStyles };
  }
  if (loading) {
    editButtonStyle.cursor = "no-drop";
    uploadButtonStyle.cursor = "no-drop";
  }
  if (!you) {
    editButtonStyle.bottom = "-85px";
    uploadButtonStyle.scale = "1.1";
    uploadButtonStyle.marginTop = "5px";
  }
  if (you) {
    editButtonStyle.right = "45px";
    uploadButtonStyle.width = "110px";
    uploadButtonStyle.height = "110px";
  }
  if (userData.isFreezed) {
    uploadButtonStyle.cursor = "no-drop";
  }

  avatarImage && (extension = avatarImage[0]);
  if (extension === "/") extension = ".jpg";
  else if (extension === "i") extension = ".png";

  return (
    <div className={styles.upload_button_container}>
      <div
        className={styles.upload_button}
        style={uploadButtonStyles ? uploadButtonStyles : {}}
      >
        {!avatarImage && !editingImage && (
          <img
            onClick={readOnly && !canRequestEdit ? undefined : () => onEdit()}
            src={uploadButton}
            style={{
              ...uploadButtonStyle,
              cursor: readOnly && !canRequestEdit ? "default" : "pointer",
              pointerEvents: readOnly && !canRequestEdit ? "none" : undefined,
            }}
            alt=""
          />
        )}
        {/*
          A picture, with nothing to click.

          The read-only case is a partner looking at a beneficiary whose
          photo their customer chose to share, so the picture itself belongs
          on the card -- it was suppressed along with the upload machinery
          below, from when the photo could not be shared at all, and the
          card drew blank however the flag was set.

          Only the picture. No cropper, no delete, and no onClick: the
          invisible trigger that overlays the avatar is part of the machinery
          below and stays unrendered, since it would otherwise take the click
          while looking like nothing at all.
        */}
        {readOnly && avatarImage && (
          <div className={styles.main_container}>
            <div className={styles.previewImageContainer}>
              <img
                className={styles.previewImage}
                src={`data:image/${extension};base64,${profile_avatar}`}
                alt=""
                onClick={canRequestEdit ? () => onEdit() : undefined}
                style={{
                  ...(you ? {} : { width: "93.5%", marginBottom: "1.5px" }),
                  cursor: canRequestEdit ? "pointer" : "default",
                }}
              />
            </div>
          </div>
        )}
        {/*
          Everything below is the upload machinery: the cropper, the delete
          handle and the invisible trigger that overlays the avatar. When
          readOnly there is nothing to upload and nothing that should respond
          to a click, so none of it is rendered.
        */}
        {!readOnly && avatarImage && (
          <>
            {/*
              No inline position. This carried `left: "50px !important"`, which
              never did anything: the CSSOM rejects a declaration whose value
              carries !important, so React's assignment left the property
              empty. The box was centred by .main_container all along, and
              spelling that out here only invited someone to "fix" the
              !important and move it for real.
            */}
            <div className={styles.main_container}>
              {loading && (
                <Spin className={styles.spinner} spinning={loading} />
              )}
              <div
                className={styles.previewImageContainer}
                style={
                  you
                    ? {
                        backgroundColor: "black",
                      }
                    : {}
                }
              >
                <img
                  onClick={() => {
                    onEdit();
                  }}
                  className={styles.previewImage}
                  src={`data:image/${extension};base64,${profile_avatar}`}
                  alt="upload button"
                  style={
                    you
                      ? { cursor: "pointer" }
                      : {
                          cursor: "pointer",
                          width: "93.5%",
                          // marginRight: "1px",
                          marginBottom: "1.5px",
                        }
                  }
                />
              </div>
              {you && (
                <div className={styles.displayDeleteAvatar}>
                  <div
                    className={styles.deletBackdrop}
                    style={{
                      left: "-1px",
                      top: "1px",
                    }}
                  />
                  <div className={styles.deleteAvatarIcon}>
                    <DeleteOutlined
                      onClick={(e) => {
                        deleteImageHandler();
                        // setPreviewImage(null);
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        {!readOnly && !avatarImage && (
          <CropperImage
            dragMode="move"
            rotatable={true}
            zoomSlider={false}
            zoomOnTouch={false}
            wheelZoomRatio={0.2}
            zoomOnWheel={true}
            modalTitle={modalTitle}
            quality={0.4}
            classNames={"xxx"}
            scalable={true}
            cropShape="round"
            restore={true}
          >
            <UploadProfilePicture
              disabled={userData.isFreezed ? true : false}
              multiple={false}
              maxCount={1}
              accept=".jpg, .jpeg, .png"
              beforeUpload={(file) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                  setPreviewImage(reader.result);
                };
                uploadImageHandler(file);
                // Prevent upload
                return false;
              }}
              itemRender={(originNode, file, fileList, { remove }) => {
                return (
                  <div
                    className={styles.main_container}
                    style={previewContainerStyles ? previewContainerStyles : {}}
                  >
                    <Spin className={styles.spinner} spinning={loading} />
                    <div className={styles.previewImageContainer}>
                      {previewImage && (
                        <>
                          <img
                            src={previewImage}
                            alt="benef. "
                            className={styles.previewImage}
                          />
                          {you && (
                            <div className={styles.displayDeleteIcon}>
                              <div className={styles.deletBackdrop} />
                              <div className={styles.deleteIcon}>
                                <DeleteOutlined
                                  onClick={(e) => {
                                    remove(file);
                                    setPreviewImage(null);
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              }}
            >
              {you && (
                <div
                  className={styles.upload_trigger}
                  style={
                    userData.isFreezed
                      ? { ...propsUploadTriggerStyles, cursor: "no-drop" }
                      : propsUploadTriggerStyles
                  }
                ></div>
              )}
            </UploadProfilePicture>
          </CropperImage>
        )}
        {!readOnly && (avatarImage || editingImage) && (
          <CropperImage
            dragMode="move"
            rotatable={true}
            zoomSlider={false}
            zoomOnTouch={false}
            wheelZoomRatio={0.2}
            zoomOnWheel={true}
            modalTitle={modalTitle}
            quality={0.4}
            classNames={"xxx"}
            scalable={true}
            cropShape="round"
            restore={true}
          >
            <UploadProfilePicture
              multiple={false}
              maxCount={1}
              accept=".jpg, .jpeg, .png"
              beforeUpload={(file) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                  setEditingImage(reader.result);
                };

                uploadImageHandler(file);
                // Prevent upload
                return false;
              }}
              itemRender={(originNode, file, fileList, { remove }) => {}}
            >
              {you && (
                <img
                  className={styles.editButton}
                  src={editButton}
                  alt="edit"
                  style={{ ...editButtonStyle }}
                />
              )}
            </UploadProfilePicture>
          </CropperImage>
        )}
      </div>
    </div>
  );
}
